'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { CheckIcon } from 'lucide-react';
interface SortItemProps {
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
}
function MetricItemFilter(t0) {
  const $ = _c(14);
  const {
    label,
    isSelected,
    onClick,
    className
  } = t0;
  const t1 = isSelected && "bg-accent text-accent-foreground font-medium";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("relative flex w-full cursor-pointer items-center justify-start rounded-sm py-1.5 pr-8 pl-2 text-sm transition-colors outline-none select-none", "hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <span>{label}</span>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isSelected) {
    t4 = isSelected && <CheckIcon className="size-4" />;
    $[5] = isSelected;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="absolute right-2 flex h-3.5 w-3.5 items-center justify-center">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClick || $[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
    t6 = <Button variant="ghost" onClick={onClick} className={t2}>{t3}{t5}</Button>;
    $[9] = onClick;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
export { MetricItemFilter };